import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Modal, Form, Space, Button, message } from "antd";

//components
import ServiceName from "./component/service_name";
import ServiceRegularPrice from "./component/service_regular_price";
import ServiceSpecialPrice from "./component/service_special_price";
import ServiceDescription from "./component/service_descriptions";
import ServiceSelectGroup from "./component/service_select_group";
import { MODEL_SERVICE } from "../../../model/service";
//redux
import { useDispatch, useSelector } from "react-redux";
import { setOpenServiceAdd } from "../../../store/var/var.action";
import { openAddService } from "../../../store/var/var.selector";
import { detailSelector } from "../../../store/branch/branch.selector";
import { addService } from "../../../store/service/service.action";

const DialogServiceAdd = () => {
  // -------------------------- VAR --------------------------
  const title = `Add a Service`;
  const [form] = Form.useForm();
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const open = useSelector(openAddService);
  const branch = useSelector(detailSelector);

  // -------------------------- FUNCTION --------------------------
  const closeDialogAdd = () => {
    dispatch(setOpenServiceAdd({ data: false }));
  };

  const onFinish = (values) => {
    if (values && branch) {
      setLoading(true);
      dispatch(
        addService({ data: values, branch: branch?.id }, (res) => {
          setLoading(false);
          if (res.status === 200) {
            message.success("Added Service Succesfully!.");
            closeDialogAdd();
            form.resetFields();
          } else {
            message.error(res.data);
          }
        })
      );
    }
  };

  const onFinishFailed = (err) => {
    console.log({ err });
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    form.setFieldsValue(MODEL_SERVICE);
  }, [form]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 0]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ServiceName />
        </Col>
        <Col xl={12} lg={12} md={24} xs={24}>
          <ServiceRegularPrice />
        </Col>
        <Col xl={12} lg={12} md={24} xs={24}>
          <ServiceSpecialPrice />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ServiceDescription />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ServiceSelectGroup />
        </Col>
      </Row>
    );
  };

  const renderFooter = () => {
    return (
      <Space>
        <Button type="default" onClick={closeDialogAdd}>
          Cancel
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          form="add-service"
          className={loading ? "disabled-btn" : "green"}
          loading={loading}
        >
          Add
        </Button>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title={title}
      open={open}
      onCancel={closeDialogAdd}
      footer={renderFooter()}
    >
      <Form
        id="add-service"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
      >
        {renderBody()}
      </Form>
    </Modal>
  );
};

export default DialogServiceAdd;
